import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusLeitura'
})
export class StatusLeituraPipe implements PipeTransform {

    private _status = {
        0 : '0 | ARQUIVO RECEBIDO',
        1 : '1 | GERADO COM SUCESSO',
        2 : '2 | EM GERAÇÃO',
        3 : '3 | ERRO AO LER ARQUIVO',
        4 : '4 | NÃO EXISTE MAPEAMENTO PARA TAG ROOT DO XML',
        5 : '5 | NÃO EXISTE MAPEAMENTO PARA ESTE LAYOUT DE PDF',
        6 : '6 | GERADO COM ERRO',
        7 : '7 | ERRO DESCONHECIDO',
        8 : '8 | PDF COM FORMATO INVALIDO',
        9 : '9 | EMAIL NAO ENVIADO',
        10: '10 | EMAIL ENVIADO COM SUCESSO',
        11: '11 | ARQUIVO LIDO E NENHUMA EMPRESA ENCONTRADA (IDENTIFICADOR NFSE BY CNPJ BASE)',
        12: '12 | EM FILA DE ENVIO DE E-MAIL',
        13: '13 | ARQUIVO COM FALTA DE DADOS',
        14: '14 | MUNICIPIO NAO CONTRATADO',
        998: '998 | DOCUMENTO EM DUPLICIDADE',
        999: '999 | DOCUMENTO INVÁLIDO | O DOCUMENTO NÃO SE REFERE A UMA NFS-E, CAPA OU CONCESSIONÁRIA',
    };

  transform(value: any, args?: any): any {
    if (this._status[value] != undefined) {
        return `${this._status[value]}`;
    }
    return `${value} (Status não mapeado)`;
  }

  public getStatus(): Object  {
      return this._status;
  }

  /*public getColor(status: number|string): string {
      if (this._statusColor[status] != undefined) {
          return `${this._statusColor[status]}`;
      }
      return 'white';
  }*/
}
